import { useEffect, useRef, useState } from 'react'
import { handleMobileButtonActionCommand } from '../../../controls'
import styles from './MobileReplayMenu.module.css'

type Props = {
  perspective: 'first_person' | 'third_person_back' | 'third_person_front'
  onOpenSettings: () => void
}

const GESTURES = [
  { mark: '↕', title: 'Взмах по ручке', detail: 'Открыть или скрыть интервал' },
  { mark: '•', title: 'Касание шкалы', detail: 'Перейти к моменту' },
  { mark: '↔', title: 'Перетаскивание', detail: 'Сдвинуть или изменить участок' },
]

export default function MobileReplayMenu ({ perspective, onOpenSettings }: Props) {
  const [helpOpen, setHelpOpen] = useState(false)
  const rootRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!helpOpen) return
    const close = (event: PointerEvent) => {
      if (event.target instanceof Node && !rootRef.current?.contains(event.target)) setHelpOpen(false)
    }
    document.addEventListener('pointerdown', close, true)
    return () => document.removeEventListener('pointerdown', close, true)
  }, [helpOpen])

  const togglePerspective = () => {
    handleMobileButtonActionCommand('general.togglePerspective', true)
    handleMobileButtonActionCommand('general.togglePerspective', false)
  }

  return (
    <div
      ref={rootRef}
      className={styles.root}
      data-replay-ui
      onPointerDown={event => event.stopPropagation()}
    >
      <div className={styles.bar}>
        <button
          type="button"
          className={`${styles.button} ${helpOpen ? styles.active : ''}`}
          onClick={() => setHelpOpen(open => !open)}
          aria-label="Жесты управления"
          aria-expanded={helpOpen}
          title="Жесты управления"
        >
          <span className="pixelart-icons-font-info-box" aria-hidden="true" />
        </button>
        <button
          type="button"
          className={`${styles.button} ${perspective === 'first_person' ? '' : styles.active}`}
          onClick={togglePerspective}
          aria-label="Сменить вид камеры"
          aria-pressed={perspective !== 'first_person'}
          title="Сменить вид камеры"
        >
          <span className="pixelart-icons-font-camera-alt" aria-hidden="true" />
        </button>
        <button
          type="button"
          className={styles.button}
          onClick={onOpenSettings}
          aria-label="Открыть настройки"
          title="Настройки"
        >
          <span className="pixelart-icons-font-sliders" aria-hidden="true" />
          <span className={styles.keyLabel} aria-hidden="true">Esc</span>
        </button>
      </div>

      <div className={`${styles.help} ${helpOpen ? styles.helpOpen : ''}`} aria-hidden={!helpOpen}>
        <div className={styles.helpHead}>
          <span className={styles.diamond} aria-hidden="true" />
          <span>Жесты</span>
        </div>
        {GESTURES.map(gesture => (
          <div key={gesture.title} className={styles.gesture}>
            <span className={styles.gestureMark} aria-hidden="true">{gesture.mark}</span>
            <span className={styles.gestureCopy}>
              <strong>{gesture.title}</strong>
              <small>{gesture.detail}</small>
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
